import { render, staticRenderFns } from "./GiftShoppingCart.vue?vue&type=template&id=4bfade58"
import script from "./GiftShoppingCart.vue?vue&type=script&lang=js"
export * from "./GiftShoppingCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports